import ErrorNotifier from 'app/scripts/services/error-notifier';
import { TDispatch } from 'state';
import { removeFromAllowlist, removeFromBlocklist } from '../../api';
import { TModerationUser, User } from './../types';
import { removeUsersStart, removeUserSuccess, removeUserFailure } from './index';

const removeUser = (type: TModerationUser) => ({ user, ip }: { user?: User; ip?: string }) => {
  return async (dispatch: TDispatch) => {
    const requestApi = getRequestForUserType(type);
    const userId = user?.get('id');

    dispatch(removeUsersStart());

    try {
      await requestApi({ userId, ip, applyOnHistory: true });
      dispatch(removeUserSuccess({ user, ip, type }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to remove user / ip from moderated list`, {
        listType: type,
        userId,
        ip
      });
      dispatch(removeUserFailure());
    }
  };
};

export function getRequestForUserType(type: TModerationUser) {
  switch (type) {
    case TModerationUser.AllowedUsers:
    case TModerationUser.AllowedIps:
      return removeFromAllowlist;
    case TModerationUser.BlockedUsers:
    case TModerationUser.BlockedIps:
      return removeFromBlocklist;
    default:
      console.error(`Unknown user type in remove user: ${type}`);
  }
}

export default removeUser;

export const removeBlockedUser = removeUser(TModerationUser.BlockedUsers);
export const removeAllowedUser = removeUser(TModerationUser.AllowedUsers);
export const removeBlockedIp = removeUser(TModerationUser.BlockedIps);
